import Vue from 'vue';
import Vuex from 'vuex';
import tab from './tab';
import order from './order';
import i18n from '../i18n/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    tab, order
  },
  state: {
    locale: 'zh'
  },
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale;
      i18n.locale = locale;
      if (tab.state.view.path === '/login') {
        window.location.href = '/scmweb/login';
      } else {
        window.location.href = '/scmweb/goods';
      }
    }
  },
  actions: {
    switchLanguage({ commit }, lang) {
      commit('SET_LOCALE', lang);
    }
  }
});
